import {
    functionalUpdate,
    makeStateUpdater,
    OnChangeFn,
    RowData,
    Table,
    TableFeature,
    Updater,
} from '@tanstack/react-table';

export type FilterAvailabilityState = {
    [columnId: string]: boolean;
};
export interface FilterAvailabilityTableState {
    filterAvailability: FilterAvailabilityState;
}
export interface FilterAvailabilityOptions {
    onFilterAvailabilityChange?: OnChangeFn<FilterAvailabilityState>;
}
export interface FilterAvailabilityInstance {
    setFilterAvailability: (updater: Updater<FilterAvailabilityState>) => void;
    getFilterAvailability: () => FilterAvailabilityState;
}

export const FilterAvailabilityFeature: TableFeature = {
    // define the new feature's initial state
    getInitialState: (state): FilterAvailabilityTableState => {
        return {
            filterAvailability: {},
            ...state,
        };
    },

    // define the new feature's default options
    getDefaultOptions: <TData extends RowData>(table: Table<TData>): FilterAvailabilityOptions => {
        return {
            onFilterAvailabilityChange: makeStateUpdater('filterAvailability', table),
        } as FilterAvailabilityOptions;
    },

    // define the new feature's table instance methods
    createTable: <TData extends RowData>(table: Table<TData>): void => {
        table.setFilterAvailability = updater => {
            const safeUpdater: Updater<FilterAvailabilityState> = old => {
                return functionalUpdate(updater, old);
            };
            return table.options.onFilterAvailabilityChange?.(safeUpdater);
        };
        table.getFilterAvailability = () => table.getState().filterAvailability;
    },
};
